import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-save-filter-modal',
    templateUrl: './save-filter-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SaveFilterModalComponent {
    private readonly modal = inject(NgbActiveModal);

    public filterName = '';

    public onCancel() {
        this.modal.dismiss();
    }

    public onSave() {
        const trimmed = this.filterName.trim();
        if (trimmed) {
            this.modal.close(trimmed);
        }
    }
}
